module.exports = __webpack_public_path__ + "static/img/2_2_1.99e8498e.png";